import {
  CustomTable,
  FilterGroupComponent,
  InputOptionCheckbox,
  Title,
} from "components";
import CircleIcon from "@mui/icons-material/Circle";

const ShareholderWithBlockedStatusSection = ({ data }) => {
  const headCells = [
    {
      id: "sid",
      label: "SID",
    },
    {
      id: "name",
      label: "Shareholder Name",
      sorter: true,
    },
    {
      id: "total_shares",
      label: "Number of Shares Blocked",
      sorter: true,
      sortKey: "ownership",
    },
    {
      id: "status",
      label: "Status",
    },
  ];

  const statusOptions = [
    {
      id: "Account blocked",
      label: (
        <div className="flex flex-row gap-2">
          <CircleIcon
            sx={{
              color: "#E52A49",
              fontSize: 8,
              mt: "3px",
            }}
          />
          Account blocked
        </div>
      ),
      value: 2,
    },
    {
      id: "Balance blocked",
      label: (
        <div className="flex flex-row gap-2">
          <CircleIcon
            sx={{
              color: "#FF5E03",
              fontSize: 8,
              mt: "3px",
            }}
          />
          Balance blocked
        </div>
      ),
      value: 3,
    },
    {
      id: "Account and balance blocked",
      label: (
        <div className="flex flex-row gap-2">
          <CircleIcon
            sx={{
              color: "#7E1728",
              fontSize: 8,
              mt: "3px",
            }}
          />
          Account and balance blocked
        </div>
      ),
      value: 4,
    },
  ];
  return (
    <div className="section map-section h-full">
      <Title title="Shareholders with Blocked Status" />
      <div className="flex flex-row gap-3 mt-5">
        <FilterGroupComponent
          showStatusFilter={false}
          showTypeFilter={false}
          showDateRangePicker={false}
          searchPlaceholder="Search by Exact Name and SID"
        />
        <InputOptionCheckbox
          label="Filter"
          options={statusOptions}
          paramsKey="status"
          paramsObjToOverride={{ page: 1 }}
        />
      </div>

      <div className="mt-5">
        <CustomTable
          id="shareholder-blocked-status-table"
          defaultSortByKey="ownership"
          headCells={headCells}
          bodyCells={data?.shareholderListBlockedStatus ?? []}
          bodyCellKey="sid"
          total={data?.total}
        />
      </div>
    </div>
  );
};

export default ShareholderWithBlockedStatusSection;
